import PropTypes from "prop-types"
import React from "react"

import { useHeader } from "../hooks/useHeader"
import { useVariants } from "../hooks/useVariants"
import { Row, TableHead, TableHeadCells } from "../styled"

/**
 * The table context aware table header
 */
export function TableHeader() {
  const { headers } = useHeader()
  const variantData = useVariants()

  return (
    <TableHead>
      <Row {...variantData} $isHeader>
        {headers.map((data, index) => {
          return (
            <TableHeadCells scope="col" key={index}>
              {data}
            </TableHeadCells>
          )
        })}
      </Row>
    </TableHead>
  )
}

TableHeader.propTypes = {
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.node)]),
}
